import { useEffect, useState } from "react";

import { doService } from "../services/ServiceHelper";
import { getScoreCategories } from "../services/ScoreService";

let scoreCategoriesCache = {};
let scoreCategoriesPromiseCache = {};

const buildMeta = (rows) => {
  const map = {};
  let tardinessCategory = null;

  for (const entry of rows) {
    map["c" + entry.id] = entry;
    if (entry.isTardiness === "Y" && tardinessCategory == null) {
      tardinessCategory = entry;
    }
  }

  return {
    categories: rows,
    scoreCategoryMap: map,
    tardinessCategory,
  };
};

export const useScoreCategories = (school, jwt) => {
  const [meta, setMeta] = useState({
    categories: [],
    scoreCategoryMap: {},
    tardinessCategory: null,
  });

  useEffect(() => {
    if (school == null || jwt == null) {
      return;
    }

    const cacheKey = `${school.eid ?? school.subdomain ?? "school"}-${jwt}`;
    if (scoreCategoriesCache[cacheKey] != null) {
      setMeta(scoreCategoriesCache[cacheKey]);
      return;
    }

    if (scoreCategoriesPromiseCache[cacheKey] == null) {
      scoreCategoriesPromiseCache[cacheKey] = new Promise((resolve) => {
        doService(getScoreCategories(school, jwt), (results) => {
          const nextMeta = buildMeta(results.data);
          scoreCategoriesCache[cacheKey] = nextMeta;
          resolve(nextMeta);
        });
      });
    }

    let isMounted = true;
    scoreCategoriesPromiseCache[cacheKey].then((nextMeta) => {
      if (isMounted) {
        setMeta(nextMeta);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [school, jwt]);

  return meta;
};
